module.exports = __webpack_public_path__ + "static/media/vf_mtshirts_core.f162520d.svg";